var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 495 495",
    style: {
      enableBackground: "new 0 0 495 495"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3282b"
    },
    d: "M207.5,247.5c0-22.056,17.944-40,40-40V0C111.028,0,0,111.028,0,247.5S111.028,495,247.5,495V287.5 C225.444,287.5,207.5,269.556,207.5,247.5z M137.5,287.5c-22.056,0-40-17.944-40-40s17.944-40,40-40s40,17.944,40,40 S159.556,287.5,137.5,287.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b3282b"
    },
    d: "M247.5,0v207.5c22.056,0,40,17.944,40,40s-17.944,40-40,40V495C383.972,495,495,383.972,495,247.5 S383.972,0,247.5,0z M357.5,287.5c-22.056,0-40-17.944-40-40s17.944-40,40-40s40,17.944,40,40S379.556,287.5,357.5,287.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M317.5,247.5c0,22.056,17.944,40,40,40v-80C335.444,207.5,317.5,225.444,317.5,247.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005ECE"
    },
    d: "M357.5,207.5v80c22.056,0,40-17.944,40-40S379.556,207.5,357.5,207.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M207.5,247.5c0,22.056,17.944,40,40,40v-80C225.444,207.5,207.5,225.444,207.5,247.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005ECE"
    },
    d: "M287.5,247.5c0-22.056-17.944-40-40-40v80C269.556,287.5,287.5,269.556,287.5,247.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M97.5,247.5c0,22.056,17.944,40,40,40v-80C115.444,207.5,97.5,225.444,97.5,247.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005ECE"
    },
    d: "M137.5,207.5v80c22.056,0,40-17.944,40-40S159.556,207.5,137.5,207.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.f02dbf619be6743e52941b441fa6704d.svg";
export { ForwardRef as ReactComponent };